import { render, staticRenderFns } from "./BoughtDialog.vue?vue&type=template&id=75e63a0a&scoped=true&"
import script from "./BoughtDialog.vue?vue&type=script&lang=js&"
export * from "./BoughtDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e63a0a",
  null
  
)

export default component.exports